const calendarFn = (root, storybookRoot, lockedDays, unlockedDays) => {
  let mdnCalendar;
  if (root.classList && root.classList.contains("mdn-Calendar")) {
    mdnCalendar = root;
  } else {
    mdnCalendar = root.querySelector(".mdn-Calendar");
  }

  lockedDays = lockedDays || [];
  unlockedDays = unlockedDays || [];
  let monthInput = mdnCalendar.querySelector(".mdn-Calendar-header-month select");
  let yearInput = mdnCalendar.querySelector(".mdn-Calendar-header-year select");
  let weeksIn = mdnCalendar.querySelector(".mdn-Calendar-weeks");
  let monthTitleIn = mdnCalendar.querySelector(".mdn-Calendar-monthTitle");
  let isReadOnly = mdnCalendar.classList.contains("mdn-Calendar--readyOnly");
  let isLockPast = mdnCalendar.getAttribute("data-mdn-lock-past") === "true";
  let isLockAll = mdnCalendar.getAttribute("data-mdn-lock-all") === "true";
  let mdnStartYear = mdnCalendar.getAttribute("data-mdn-start-year");
  let mdnEndYear = mdnCalendar.getAttribute("data-mdn-end-year") || new Date().getFullYear();
  let mdnSelectedYear = mdnCalendar.getAttribute("data-mdn-selected-year");
  let currentDateYear = mdnCalendar.getAttribute("data-mdn-selected-year") || yearInput.value;
  let mdnSelectedMonth = mdnCalendar.getAttribute("data-mdn-selected-month") || monthInput.value;

  mdnCalendar.classList.add("notranslate");

  if(mdnStartYear) {
    let html = "";
    for (let i = mdnStartYear; i <= mdnEndYear; i++) {
      html += `<option value="${i}">${i}</option>`
    }

    if(yearInput) yearInput.innerHTML = html;
  }

  if (mdnSelectedYear && yearInput) {
    yearInput.value = mdnSelectedYear;
  }
  if (mdnSelectedMonth) {
    if (!isNaN(Number(mdnSelectedMonth))) {
      mdnSelectedMonth = Number(mdnSelectedMonth) - 1;
    } else if (monthInput) {
      monthInput.value = mdnSelectedMonth;
    }
  }

  

  let currentDateMonth = $getMonthNumber(mdnSelectedMonth || monthInput.value);
  let currentDateDay = mdnCalendar.getAttribute("data-mdn-selected-day");
  let currentDate = new Date(currentDateYear, $getMonthNumber(currentDateMonth), currentDateDay);
  mdnCalendar.setAttribute("data-mdn-current-date", currentDate);
  mdnCalendar.setAttribute("data-mdn-current-focused-date", currentDate);
  mdnCalendar.setAttribute("aria-label", getFriendlyCurrentDate(currentDate));
  let selectedDate = currentDate;
  let selectedDateYear = currentDateYear;
  let selectedDateMonth = currentDateMonth;
  let selectedDateDay = currentDateDay;

  let lockDaysTo = currentDate;
  lockOptions();
  unlockOptions();

  if (!isReadOnly) {
    monthInput.onchange = yearInput.onchange = handleChange;
  }

  handleChange(null, true);

  mdnCalendar.getDate = () => {
    return new Date(
      mdnCalendar.dataset.mdnCurrentDate
    )
  }

  mdnCalendar.lockDays = function(days) {
    lockedDays = days || lockedDays || [];
    handleChange(null, true);
  };

  mdnCalendar.unlockDays = function(days) {
    unlockedDays = days || unlockedDays || [];
    handleChange(null, true);
  };

  function getFriendlyCurrentDate(date) {
    let month = $getFriendlyMonthName(date.getMonth());
    return `Dia ${date.getDate()} de ${month} de ${date.getFullYear()}.`;
  }

  function lockOptions() {
    if (!isLockPast) return;
    let monthOptions = monthInput.querySelectorAll("option");
    let yearOptions = yearInput.querySelectorAll("option");
    for (let i = 0; i < currentDateMonth; i++) {
      monthOptions[i].disabled = true;
    }

    for (let i = 0, lgt = yearOptions.length; i < lgt; i++) {
      if (yearOptions[i].value < currentDateYear) {
        yearOptions[i].disabled = true;
      }
    }
  }

  function unlockOptions() {
    if (!isLockAll) return;
    let monthOptions = monthInput.querySelectorAll("option");
    let yearOptions = yearInput.querySelectorAll("option");

    for (let i = 0, lgt = yearOptions.length; i < lgt; i++) {
      yearOptions[i].disabled = !$hasYear(yearOptions[i].value, unlockedDays);
    }

    for (let i = 0, lgt = monthOptions.length; i < lgt; i++) {
      monthOptions[i].disabled = !$hasMonthAndYear($getMonthNumber(monthOptions[i].value), selectedDateYear, unlockedDays);
    }
  }

  function renderMonth(year, month, day, willMarkDay) {
    let friendlyMonth = $getFriendlyMonthName(month);
    let firstDayIndex = $getFirstDayIndex(year, month);
    let daysInMonth = $getDaysInMonth(year, month);
    let weeksInMonth = $getWeeksInMonth(year, month);
    let html = "";

    for (let i = 0, loopDay = 1; i < weeksInMonth; i++) {
      html += `
        <li class="mdn-Calendar-weeks-week" aria-label="Semana ${i + 1} do mês de ${friendlyMonth}">
          <ul class="mdn-Calendar-monthDays">`;
      for (let j = 0; j < 7 && loopDay <= daysInMonth; j++) {
        let weekDay = $getWeekDay(j);
        let willPrintDate = j >= firstDayIndex;
        let label = willPrintDate ? `${weekDay}, dia ${loopDay} de ${friendlyMonth} de ${year}` : ``;
        let content = "";
        let tempDate = new Date(year, month, loopDay);
        let lockDay = lockedDays.map(Number).indexOf(+tempDate) > -1;
        let willLockDay;

        if (isLockAll && unlockedDays.map(Number).indexOf(+tempDate) < 0) {
          willLockDay = true;
        } else {
          willLockDay = (isLockPast && loopDay < lockDaysTo.getDate() && month === lockDaysTo.getMonth()) || lockDay;
        }

        if (isReadOnly) {
          content = willPrintDate ? `<span class="mdn-Calendar-monthDays-day-anchor">${loopDay}</span>` : ``;
        } else {
          content = willPrintDate ? `<a class="mdn-Calendar-monthDays-day-anchor" aria-label="${label || ""}" href="#"
          ${willLockDay ? "tabindex='-1'" : ""}>${loopDay}</a>` : ``;
        }
        html += `
          <li aria-label="${label || ""}" ${willPrintDate ? 'data-mdn-day="' + loopDay + '" data-mdn-date="' + tempDate + '"'  : ""} class="mdn-Calendar-monthDays-day ${
          !willPrintDate || isReadOnly ? "mdn-Calendar-monthDays-day--readOnly" : ""
        } ${willLockDay ? "mdn-Calendar-monthDays-day--locked" : ""}">
        ${content || ""}
        </li>`;
        willPrintDate && loopDay++;
        willPrintDate && (firstDayIndex = 0);
      }
      html += `</ul></li>`;
    }

    weeksIn.innerHTML = html;

    willMarkDay && markDay(day);
  }

  function handleChange(evt, isFirstInit) {
    if (isReadOnly) {
      monthTitleIn.innerHTML = `${$getFriendlyMonthName(currentDateMonth)} de ${currentDateYear}`;
      return renderMonth(currentDateYear, currentDateMonth, currentDateDay, true);
    }

    let newYear = yearInput.value;
    let newMonth = $getMonthNumber(monthInput.value);
    let willMarkDay = currentDateYear == newYear && currentDateMonth == newMonth;

    selectedDate = new Date(newYear, newMonth, willMarkDay ? currentDateDay : 1);
    selectedDateYear = selectedDate.getFullYear();
    selectedDateMonth = selectedDate.getMonth();
    selectedDateDay = selectedDate.getDate();

    renderMonth(selectedDateYear, selectedDateMonth, selectedDateDay, isFirstInit || willMarkDay);

    // Bind after render
    let days = mdnCalendar.querySelectorAll(".mdn-Calendar-weeks-week a");
    $bindMultiple(days, "click", updateDate);
    $bindMultiple(days, "keydown", setKeyboardNavigation);
    unlockOptions();
  }

  function markDay(day) {
    let currentActive = mdnCalendar.querySelector(".mdn-Calendar-monthDays-day--active");
    currentActive && currentActive.classList.remove("mdn-Calendar-monthDays-day--active");

    mdnCalendar.querySelector(`[data-mdn-day="${day}"]`).classList.add("mdn-Calendar-monthDays-day--active");
  }

  function setKeyboardNavigation(e) {
    let key = e.keyCode;
    let currentFocused = mdnCalendar.getAttribute("data-mdn-current-focused-date");

    switch (key) {
      case keys.left:
        focusDate(currentFocused, -1);
        break;
      case keys.right:
        focusDate(currentFocused, 1);
        break;
      case keys.down:
        focusDate(currentFocused, 7);
        break;
      case keys.up:
        focusDate(currentFocused, -7);
        break;
      case keys.tab: {

        let el = document.activeElement.parentElement;
        let tabCurrentDate = el.getAttribute("data-mdn-date");
        addDays(tabCurrentDate, 0)

        if (e.shiftKey) {
          addDays(tabCurrentDate, -1);
        } else {
          addDays(tabCurrentDate, 1);
        }
      }
    }
  }

  function addDays(date, days) {
    const focusDateNew = new Date(date);
    focusDateNew.setDate(focusDateNew.getDate() + days);
    mdnCalendar.setAttribute("data-mdn-current-focused-date", focusDateNew);
    return focusDateNew;
  }

  function focusDate(currentFocused, days) {
    let day = addDays(currentFocused, days).getDate();
    let el = mdnCalendar.querySelectorAll(`[data-mdn-day="${day}"]`);
    el.forEach(function(day) {
      day.firstElementChild.focus();
    });
  }

  function updateDate(e) {
    e && e.preventDefault && e.preventDefault();

    if (this.parentNode.classList.contains("mdn-Calendar-monthDays-day--locked")) return;

    markDay(this.innerText);

    let newYear = yearInput.value;
    let newMonth = $getMonthNumber(monthInput.value);
    currentDate = new Date(newYear, newMonth, Number(this.innerHTML));
    mdnCalendar.setAttribute("data-mdn-current-date", currentDate);
    mdnCalendar.setAttribute("data-mdn-current-focused-date", currentDate);
    mdnCalendar.setAttribute("aria-label", getFriendlyCurrentDate(currentDate));
    currentDateYear = currentDate.getFullYear();
    currentDateMonth = currentDate.getMonth();
    currentDateDay = currentDate.getDate();

    updateSelectedDate(currentDate);
  }

  function updateSelectedDate(date) {
    selectedDate = date;
    selectedDateYear = selectedDate.getFullYear();
    selectedDateMonth = selectedDate.getMonth();
    selectedDateDay = selectedDate.getDate();

    mdnCalendar.setAttribute("data-mdn-current-date", selectedDate);
    mdnCalendar.setAttribute("data-mdn-selected-day", selectedDateDay);
    mdnCalendar.setAttribute("data-mdn-current-month", selectedDateMonth);
    mdnCalendar.setAttribute("data-mdn-current-year", selectedDateYear);

    console.log(selectedDate);
  }

  // Key list for easy reference
  let keys = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46,
    tab: 9
  };

  // Add or substract depending on key pressed
  // let direction = {
  //   37: -1,
  //   38: -1,
  //   39: 1,
  //   40: 1
  // };

  function $hasYear(value, where) {
    if (!where) return false;
    let finded = false;
    for (let i = 0, lgt = where.length; i < lgt; i++) {
      let year = where[i].getFullYear();
      finded = year == value;
      if (finded) break;
    }
    return finded;
  }

  function $hasMonthAndYear(monthValue, yearValue, where) {
    if (!where) return false;
    let finded = false;
    for (let i = 0, lgt = where.length; i < lgt; i++) {
      let month = where[i].getMonth();
      let year = where[i].getFullYear();
      finded = month == monthValue && year == yearValue;
      if (finded) break;
    }
    return finded;
  }

  function $bindMultiple(who, what, fn) {
    who = who.length ? who : [who];
    for (let i = 0, lgt = who.length; i < lgt; i++) {
      who[i].addEventListener(what, fn);
    }
  }

  function $getWeekDay(day) {
    return ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"][day];
  }

  function $getDaysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }

  function $getFirstDayIndex(year, month) {
    return new Date(year, month).getDay();
  }

  function $getWeeksInMonth(year, month) {
    // month_number is in the range 1..12
    let firstOfMonth = new Date(year, month - 1, 1);
    let lastOfMonth = new Date(year, month, 0);
    let used = firstOfMonth.getDay() + 6 + lastOfMonth.getDate();

    return Math.ceil(used / 7);
  }

  function $getMonthNumber(month) {
    return typeof month === "number"
      ? month
      : ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"].indexOf(month);
  }

  function $getFriendlyMonthName(monthNumber) {
    return ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][monthNumber];
  }

  return storybookRoot ? storybookRoot : root;
};

export default calendarFn;
